import RestResource from '../rest.service';

export default class ProjectionActivitiesService extends RestResource {
  setProjection(projectionId) {
    //set parent -> it will show the Activities that belong to one Projection
    this.parents = [];
    this.parents.push(projectionId);
    return this;
  }

  map(entity) {
    return {
      comment: entity.comment,
      quantity: entity.quantity,
      projection_state_id: entity.state,
      next_follow_up_date: entity.nextFollowUpDate,
    };
  }

  constructor() {
    //Call parent's constructor to set this.resource
    super('projections/$0/activities');
  }
}
